import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    placeholder: { type: String, default: "" },
    max: { type: Number, default: 0 }
  }

  connect() {
    const options = {
      plugins: ["remove_button"],
      placeholder: this.placeholderValue || null,
      allowEmptyOption: true,
    }

    if (this.maxValue > 0) {
      options.maxItems = this.maxValue
    }

    this.tomSelect = new TomSelect(this.element, options)
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }
}
